//@ts-nocheck
import React, { useEffect, useState, useContext } from "react";
import {
  Button,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Chip,
  Typography,
  IconButton,
  DialogActions,
  Alert,
  Checkbox,
  Autocomplete,
  FormControlLabel,
  InputAdornment,
} from "@mui/material";
import ImageUpload from "../../components/ImageUpload";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import { useGetToken } from "../../hooks/useGetToken";
import Context from "../../context";
import CloseIcon from "@mui/icons-material/Close";
import ImageWithTick from "../../components/ImageWithTick";
import { makeStyles } from "tss-react/mui";
import TrainingList from "../../components/TrainingList";
import QualificationsApp from "../../components/QualificationsApp";
import {
  formatUserQualificationResponse,
  UserQualificationResponseType,
  validateField,
} from "../../components/helper";
import {
  baseFieldRulesFrom,
  getFieldSchema,
} from "../../services/countryConfigService";
import { useGlobalStateContext } from "../../context/globalState";
import StatusCardProps from "../../components/StatusCardProps";
import AlertBox from "../../components/AlertBox";
import { useTranslation } from "react-i18next";
import TextLabel from "../../components/TextLabel";
import StyledButtons from "../../styledComponents/styledButtons";
import Loading from "../../components/Loading";
import { apiErrorMessage, logUserAction } from "../../utils/apiUtils";
import { CONSTANTS } from "../../CONSTANTS";
import KoneEmployeeApp from "../KoneEmployeeApp";
import { fetchBusinessTypes } from "../../services/TrainingsHeaderViewService";

interface InstallerFormValues {
  firstName: string;
  lastName: string;
  id: string;
  email: string;
  phoneNumber: string;
  assessorName: string;
  frontline: string;
  country: string;
  company: string;
  role: string;
  customRoleName: string;
  qualified: string;
  comments: string;
  photo: string;
  fileType: string;
  status: string;
}

const useStyles = makeStyles()(() => ({
  content: {
    padding: "20px",
    marginTop: "20px",
    width: "95%",
  },
  headerInfo: {
    display: "flex",
    justifyContent: "center",
    textAlign: "left",
  },
  container: {
    height: "100%",
    margin: "0",
  },
  wrapper: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  header: {
    marginLeft: "20px !important",
  },
  roleContainer: {
    display: "inline-flex",
    position: "relative",
    left: "20%",
    top: "-5%",
    zIndex: 100,
  },
  roleText: {
    display: "inline",
    marginTop: "-10px",
    marginLeft: "-5px",
  },
  avatarMargin: {
    marginLeft: "-40px !important",
    marginTop: "10px !important",
  },
  uploadButtonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "10px",
  },

  uploadButton: {
    backgroundColor: "blue" /* Blue color for the button */,
    color: "white" /* White text on the button */,
    padding: "10px 20px" /* Adjust padding for size */,
    border: "none" /* Remove the border */,
    borderRadius: "5px" /* Optional rounded corners */,
    cursor: "pointer" /* Change cursor to pointer on hover */,
    fontSize: "14px" /* Adjust font size */,
  },
}));
interface ProfileWithQualProps {
  userId: string;
  onCloseCb: (value: boolean) => void;
  companyId: string;
}

const ProfileWithQual: React.FC<ProfileWithQualProps> = ({
  userId,
  onCloseCb,
  onUpdateInstallers,
  companyId,
}) => {
  const {
    supplierType,
    blockReason,
    statusEndDate,
    loading,
    beginLoading,
    endLoading,
    setUserFirstName,
    setUserLastName,
    userFirstName,
    userLastName,
    qualificationsList,
    setQualificationsList,
    passportTypeId,
    setPassportTypeId,
    qualificationTypeId,
    setQualificationTypeId,
    selectedBusinessType,
    selectedBusinessTypeId,
    businessTypesList,
    setBusinessTypesList,
    userPreference: { languagePreference },
    setBlockReason,
    setStatusEndDate,
    adminRole,
  } = useGlobalStateContext();

  const {
    authState: { user },
  } = useContext(Context);
  const { t } = useTranslation();
  const [getToken] = useGetToken();
  const [data, setResponseData] = useState<any[]>([]);
  const [frontlineList, setFrontlineList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [installerRoleList, setInstallerRoleList] = useState([]);
  const [countryList, setCountryList] = useState<any[]>([]);
  const [photo, setPhoto] = useState<string | null>(null);
  const [values, setValues] = useState<InstallerFormValues>({
    firstName: "",
    lastName: "",
    id: "",
    email: "",
    phoneNumber: "",
    assessorName: "",
    frontline: "",
    country: "",
    company: "",
    role: "",
    customRoleName: "",
    qualified: [],
    comments: "",
    photo: "",
    fileType: "",
    status: "",
    statusReason: "",
    statusEndDate: "",
    businessTypeId: [],
  });
  const [error, setError] = useState<string | null>(null);
  const [trainingData, setTrainingData] = useState<any[]>([]);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [oldValues, setOldValues] = useState({}); // Old values state
  // const [values, setValues] = useState<InstallerFormValues>({})
  const [showAlert, setShowAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [selectedCountry, setSelectedCountry] = React.useState("");
  const [dynamicFields, setDynamicFields] = useState([]);
  // Per-country rules for the built-in fields, keyed by the form's own names.
  const [baseRules, setBaseRules] = useState({});
  /**
   * Whether to render a built-in field. Defaults to shown, so the form is never
   * missing fields while the country's config is still loading, and anything
   * the catalog does not list as configurable is always shown.
   */
  const showBaseField = (fieldName: string): boolean => {
    const rule = baseRules[fieldName];
    return rule ? rule.isVisible : true;
  };
  /**
   * Whether a built-in field is mandatory for this country. `fallback` is the
   * form's own rule, used for fields the catalog does not make configurable and
   * while the country's config is still loading.
   */
  const requireBaseField = (fieldName: string, fallback = true): boolean => {
    const rule = baseRules[fieldName];
    return rule ? rule.isMandatory : fallback;
  };
  const [dynamicFieldValues, setDynamicFieldValues] = useState<{
    [key: string]: string;
  }>({});
  const [dynamicFieldErrors, setDynamicFieldErrors] = useState<{
    [key: string]: string;
  }>({});
  const [profileFormData, setProfileFormData] = useState({
    firstName: "",
    lastName: "",
    emailId: "",
    contactNumber: "",
    assessorName: "",
    frontlineId: "",
    countryId: "",
    companyCode: "",
    roleId: "",
    customRoleName: "",
    qualified: "",
    comments: "",
    photo: "",
    userId: "",
    status: "",
    koneEmployeeId: "",
    statusReason: "",
    statusEndDate: "",
    businessTypeId: [],
    managerId: "",
  });
  // Manager (foreman) candidates for this employee's vendor. Subcontractors only.
  const [managerList, setManagerList] = useState([]);

  const { classes } = useStyles();
  // Manage dialog open state
  const [openDialog, setOpenDialog] = useState(true);

  // Handle Alert State
  const [alertState, setAlertState] = useState({
    message: "",
    type: "",
  });

  // Handle Delete Confirmation Dialog
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  // First useEffect hook: Fetch data on initial page load
  useEffect(() => {
    const fetchData = async () => {
      handleSubmit(); // This will fetch user data and then load frontlines/roles with correct params
    };
    fetchData();
    fetchBusinessTypesData();
    return () => {
      // Clear context state on unmount
      if (qualificationsList.length > 0) {
        setQualificationsList([]);
      }
      if (passportTypeId) {
        setPassportTypeId("");
      }
      if (qualificationTypeId) {
        setQualificationTypeId("");
      }
    };
  }, []);

  // Update statusReason in values state when there is change in blockReason in context (which is updated from StatusCardProps modal)
  useEffect(() => {
    setValues((prevValues) => ({
      ...prevValues,
      statusReason: blockReason,
    }));
  }, [blockReason]);

  // Update statusEndDate in values state when there is change in statusEndDate in context (which is updated from StatusCardProps modal)
  useEffect(() => {
    setValues((prevValues) => ({
      ...prevValues,
      statusEndDate: statusEndDate,
    }));
  }, [statusEndDate]);

  useEffect(() => {
    if (data?.profileImgName) {
      handleImagedata();
    }
  }, [data]);

  // Second useEffect hook: Fetch vendors data only when selectedCountry is set

  useEffect(() => {
    fetchCountryData(profileFormData.frontlineId);
  }, [profileFormData.frontlineId]);

  // Second useEffect hook: Fetch vendors data only when selectedCountry is set
  useEffect(() => {
    const fetchData = async () => {
      if (selectedCountry) {
        // Ensure countryList is available before fetching vendors data
        const countryCode = getCountryCodeById(selectedCountry);
        if (countryCode) {
          await fetchVendorsData(countryCode); // Ensure country code is passed as query parameter
        }
      }
    };

    fetchData(); // Run the fetch when selectedCountry is updated
  }, [selectedCountry]); // Dependency on selectedCountry ensures it runs after it's set

  useEffect(() => {
    if (
      profileFormData.firstName &&
      profileFormData.firstName !== userFirstName
    ) {
      setUserFirstName(profileFormData.firstName);
    }
    if (profileFormData.lastName && profileFormData.lastName !== userLastName) {
      setUserLastName(profileFormData.lastName);
    }
  }, [profileFormData.firstName, profileFormData.lastName]);

  const getCountryCodeById = (countryId) => {
    // Check if countryList is available and find the country code by country_id
    return countryList?.find((country) => country.country_id === countryId)
      ?.country_code;
  };

  const fetchCountryData = async (frontlineId: string) => {
    if (!frontlineId) return;
    const loadingToken = beginLoading("profile-qual-countries");
    const token = await getToken();
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      };
      const uri = `${process.env.REACT_APP_API_ENDPOINT}/v1/countries?frontlineId=${frontlineId}`;
      const response = await axios.get(uri, config);
      setCountryList(response.data);
    } catch (error) {
      console.error("Error fetching countries:", error);
      setAlertState({
        message: t("error_messages.fetchCountriesShortError"),
        type: "error",
      });
    } finally {
      endLoading(loadingToken);
    }
  };

  const fetchFrontlineData = async (regionId?: string | number) => {
    const loadingToken = beginLoading("profile-qual-frontlines");
    const token = await getToken();
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      };
      const region = regionId || "100";
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT}/v1/frontlines/${region}`,
        config,
      );
      setFrontlineList(response.data);
    } catch (error) {
      console.error("Error fetching frontlines:", error);
      setAlertState({
        message: t("error_messages.fetchFrontlinesShortError"),
        type: "error",
      });
    } finally {
      endLoading(loadingToken);
    }
  };

  const fetchBusinessTypesData = async () => {
    const token = await getToken();
    try {
      const businessTypesData = await fetchBusinessTypes(
        token,
        languagePreference || "en",
      );
      setBusinessTypesList(businessTypesData);
    } catch (error) {
      console.error("Error fetching business types:", error);
    }
  };

  const fetchRolesData = async (businessTypeId?: number) => {
    const loadingToken = beginLoading("profile-qual-roles");
    const token = await getToken();
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      };
      let url = `${process.env.REACT_APP_API_ENDPOINT}/v1/roles`;
      if (businessTypeId) {
        url += `?businessTypeId=${businessTypeId}`;
      }
      if (supplierType === "vendor") {
        url += businessTypeId
          ? "&companyType=subcontractor"
          : "?companyType=subcontractor";
      } else {
        url += businessTypeId ? "&companyType=kone" : "?companyType=kone";
      }
      const response = await axios.get(url, config);
      setInstallerRoleList(response.data);
    } catch (error) {
      console.error("Error fetching roles:", error);
      setAlertState({
        message: t("error_messages.fetchRolesShortError"),
        type: "error",
      });
    } finally {
      endLoading(loadingToken);
    }
  };

  const fetchVendorsData = async (countryCode) => {
    const loadingToken = beginLoading("profile-qual-vendors");
    const token = await getToken();
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      };

      const response = await axios.get(
        supplierType === "vendor"
          ? `${process.env.REACT_APP_API_ENDPOINT}/v1/company/getVendors?countries="${countryCode}"&frontline=${profileFormData.frontlineId}&limit=-1`
          : `${process.env.REACT_APP_API_ENDPOINT}/v1/company/getCompany?countries="${countryCode}"&limit=-1&businessTypeId=${selectedBusinessTypeId}&lang=${languagePreference || "en"}`,
        config,
      );
      const finalResponse =
        supplierType === "supplier"
          ? response.data.company
          : response.data.vendors;
      setCompanyList(finalResponse);
    } catch (error) {
      console.error("Error fetching companies:", error);
      setAlertState({
        message: t("error_messages.fetchCompaniesShortError"),
        type: "error",
      });
    } finally {
      endLoading(loadingToken);
    }
  };

  // Manager candidates for one vendor. A manager must be in the same company as
  // the person reporting to them, so this is always scoped by vendor and is
  // re-fetched whenever the employee is moved to a different one.
  const fetchManagersData = async (vendorId: string) => {
    if (!vendorId) {
      setManagerList([]);
      return;
    }
    try {
      const token = await getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT}/v1/installers/managers?vendorId=${vendorId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );
      setManagerList(response.data?.managers || []);
    } catch (error) {
      // The manager is optional, so a missing candidate list must not block the
      // rest of the edit - the field just stays empty.
      console.error("Error fetching managers:", error);
      setManagerList([]);
    }
  };

  const handleCancel = (event, reason) => {
    // Prevent closing on backdrop click or escape key, allow only explicit cancel
    if (reason === "backdropClick" || reason === "escapeKeyDown") return;
    if (event?.type === "keydown" && event.key !== "Enter") return;
    // Reset form values and close dialog
    setOpenDialog(false); // Close dialog on cancel
    onCloseCb && onCloseCb(false);
    localStorage.removeItem("selectedQualifications");
    setUserFirstName("");
    setUserLastName("");
    setQualificationsList([]);
  };

  // Handle delete button click
  const handleDeleteClick = () => {
    setShowDeleteDialog(true);
  };

  // Handle delete confirmation cancel
  const handleDeleteCancel = () => {
    setShowDeleteDialog(false);
  };

  // Handle delete confirmation
  const handleDeleteConfirm = async () => {
    const loadingToken = beginLoading("profile-qual-delete");
    setShowDeleteDialog(false);

    try {
      const token = await getToken();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      };

      const deletePayload = {
        userId: data.userId,
        emailId: data.emailId,
      };

      const response = await axios.delete(
        `${process.env.REACT_APP_API_ENDPOINT}/v1/installers/delete`,
        {
          ...config,
          data: deletePayload,
        },
      );

      if (response.data) {
        // Stop loading to show success message
        endLoading(loadingToken);

        // Show success message
        setSuccessMessage(
          response.data.message ||
            t("adminDashboard.form.deleteConfirmation.successMessage"),
        );
        setShowAlert(true);

        // Wait 3 seconds to show the success message
        await new Promise((resolve) => setTimeout(resolve, 3000));

        // Refresh user list
        const businessTypeValue = selectedBusinessTypeId || 100; // Default to 100 if no business type is selected
        const updatedResponse = await axios.get(
          `${process.env.REACT_APP_API_ENDPOINT}/v1/installers/${companyId}?businessTypeId=${businessTypeValue}`,
          config,
        );
        onUpdateInstallers(updatedResponse.data.users);

        // Close dialog and callback
        setOpenDialog(false);
        onCloseCb && onCloseCb(false);
        logUserAction(token, user.username, CONSTANTS.USER_ACTION.PROFILE);
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      endLoading(loadingToken); // Stop loading on error
      setAlertState({
        message: apiErrorMessage(
          error,
          t("adminDashboard.form.deleteConfirmation.errorMessage"),
        ),
        type: "error",
      });
    }
  };

  // Handle close alert
  const handleCloseAlert = () => {
    setAlertState({ message: "", type: "" });
  };

  const handleImagedata = async () => {
    const token = await getToken();
    const uri = `${process.env.REACT_APP_API_ENDPOINT}/v1/attachments/download`;
    const config: AxiosRequestConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    const payload = {
      attachments: [
        {
          filename: data?.profileImgName,
          location: data?.profileImgName,
        },
      ],
    };

    try {
      const response = await axios.post(uri, payload, config);
      const imageUrl = response.data.imageUrl[0].signedUrl;
      // Held outside `values`, which is the set of fields the admin has edited
      // and is reset once the load finishes. The stored image is not an edit.
      setPhoto(imageUrl);
    } catch (err) {
      console.error(err);
      setError("Failed to fetch image data");
    }
  };

  const handleUpdate = async () => {
    const loadingToken = beginLoading("profile-qual-update");
    setErrors({}); // Reset errors before validation
    setDynamicFieldErrors({}); // Reset dynamic field errors
    setAlertState({ message: "", type: "" }); // Reset alert state before validation

    // Validate dynamic fields
    const dynamicErrors = validateDynamicFields();
    if (Object.keys(dynamicErrors).length > 0) {
      setDynamicFieldErrors(dynamicErrors);
      endLoading(loadingToken);
      return;
    }

    try {
      const token = await getToken(); // Get the token from your custom hook
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: token, // Include the token in the header if required
        },
      };
      let updatedData = {};

      // Loop through each field in `values` and compare it with `oldValues` (the original data)
      Object.keys(values).forEach((key) => {
        // Skip photo and fileType - handle them separately
        if (key === "photo" || key === "fileType") {
          return;
        }

        // Business type is an array of ids - compare by content, not reference
        if (key === "businessTypeId") {
          const currentIds = Array.isArray(values.businessTypeId)
            ? [...values.businessTypeId].sort()
            : [];
          const originalIds = Array.isArray(oldValues.businessTypeId)
            ? [...oldValues.businessTypeId].sort()
            : [];
          if (JSON.stringify(currentIds) !== JSON.stringify(originalIds)) {
            updatedData["businessTypeIds"] = values.businessTypeId;
          }
          return;
        }

        // Normalize values by trimming whitespace
        const currentValue =
          values[key] && values[key].trim ? values[key].trim() : values[key];
        const originalValue =
          oldValues[key] && oldValues[key].trim
            ? oldValues[key].trim()
            : oldValues[key];

        // If the value has changed, add the updated value
        if (currentValue !== originalValue) {
          if (key === "qualified" && Array.isArray(currentValue)) {
            updatedData[key] =
              currentValue.length > 0 ? currentValue.join(",") : ""; // Convert array to comma-separated string
          } else if (key === "customRoleName" && values.roleId === "Others") {
            updatedData["customRoleName"] = values[key]; // Map customRoleName to customRoleName if roleId is 'Others'
          } else {
            updatedData[key] = values[key]; // Send the updated value
          }
        } else if (
          key === "status" &&
          values.statusReason !== oldValues.statusReason
        ) {
          // Status value unchanged but statusReason changed - still send status so backend updates statusReason alongside it
          updatedData[key] = values[key];
        }
        // Unchanged fields are skipped - omitting them from updatedData prevents the backend from overwriting columns with null
      });
      // Handle photo and fileType separately - only include if it's base64 data (new upload)
      if (values.photo && values.photo.startsWith("data:image/")) {
        updatedData.photo = values.photo;
        updatedData.fileType = values.fileType;
      }

      let isQualificationModified = false;

      if (oldValues?.trainingData) {
        if (oldValues.trainingData.length !== qualificationsList?.length) {
          isQualificationModified = true;
        } else {
          isQualificationModified = !(
            Array.isArray(qualificationsList) &&
            Array.isArray(oldValues.trainingData) &&
            qualificationsList.length === oldValues.trainingData.length &&
            qualificationsList.every((qual, idx) => {
              const oldQual = oldValues.trainingData[idx];
              // Compare relevant fields, adjust as needed
              return JSON.stringify(qual) === JSON.stringify(oldQual);
            })
          );
        }
      }

      if (isQualificationModified) {
        updatedData["trainingData"] = qualificationsList;
      } else if (updatedData["trainingData"]) {
        delete updatedData["trainingData"]; // Remove trainingData if not modified
      }

      // Check for dynamic field changes and add to updatedData
      dynamicFields.forEach((field: any) => {
        const currentValue = dynamicFieldValues[field.fieldKey];
        const originalValue = oldValues[field.fieldKey];
        if (currentValue !== originalValue) {
          updatedData[field.fieldKey] = currentValue;
        }
      });

      const validationErrors = {};
      for (const key in updatedData) {
        const error = validateField(
          key,
          updatedData[key],
          supplierType === "vendor",
        );
        if (error) {
          validationErrors[key] = error;
        }
      }
      if (Object.keys(validationErrors).length > 0) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          ...validationErrors,
        }));
        endLoading(loadingToken);
        return;
      }

      const userId = data.userId;
      const formData = { updatedData, userId, supplierType };
      // Send the put request to your API endpoint
      const response = await axios.put(
        `${process.env.REACT_APP_API_ENDPOINT}/v1/updateUser`,
        formData,
        config,
      );

      if (response.data) {
        const businessTypeValue = selectedBusinessTypeId || 100; // Default to 100 if no business type is selected
        const updatedResponse = await axios.get(
          `${process.env.REACT_APP_API_ENDPOINT}/v1/installers/${companyId}?businessTypeId=${businessTypeValue}`,
          config,
        );
        onUpdateInstallers(updatedResponse.data.users);
        if (updatedResponse.data) {
          setSuccessMessage(t("successMessages.userAddedSuccessfully"));
          setShowAlert(true); // Show alert
          setOpenDialog(false);

          // Send POST request with token and email
        }
      }

      // Optionally reset form after successful submission
      setValues({});
      setOpenDialog(false);
      onCloseCb();
      logUserAction(token, user.username, CONSTANTS.USER_ACTION.PROFILE); // Send POST request with token and email
    } catch (error) {
      // Handle error if the request fails
      setError("Error updating user:", error);
      setAlertState({
        message: apiErrorMessage(error, t("error_messages.updateUserError")),
        type: "error",
      });
    } finally {
      endLoading(loadingToken); // Set loading to false after data is fetched
      setUserFirstName("");
      setUserLastName("");
    }
  };

  const getDynamicFieldsForUserCountry = async (userData: any) => {
    const token = await getToken();
    try {
      // Resolve the schema for THIS user's audience so a field targeted at the
      // other company type, or at business types this user is not in, never
      // reaches the form. `vendorId` is the same signal the server keys on -
      // subcontractor employees are the only rows that carry one.
      const schema = await getFieldSchema(userData.countryId, token, {
        companyType: userData.vendorId ? "subcon" : "kone",
        businessTypeIds: (userData.businessTypes || []).map((bt) =>
          Number(bt.id),
        ),
      });
      // The built-in fields are rendered natively rather than from the schema,
      // so their per-country visibility overrides have to be picked out here -
      // otherwise hiding one in the country config would have no effect here.
      setBaseRules(baseFieldRulesFrom(schema || []));
      const dynamicFields = (schema || [])
        .filter((item) => item.source === "custom" && item.isVisible)
        .map((item) => ({
          fieldKey: item.key,
          displayName: item.displayName || item.key,
          fieldType: item.fieldType,
          isMandatory: item.isMandatory ? 1 : 0,
          charLimit: item.charLimit,
          fieldOptions: item.fieldOptions,
        }));
      setDynamicFields(dynamicFields);
      // Set Dynamic Field Values and Errors based on the fetched fields.
      // Values come from the per-country custom table (userData.customFields),
      // falling back to any legacy column value on the user row.
      const customValues = userData.customFields || {};
      if (dynamicFields && dynamicFields.length > 0) {
        const initialDynamicFieldValues = {};
        const initialDynamicFieldErrors = {};
        dynamicFields.forEach((field) => {
          const raw =
            customValues[field.fieldKey] !== undefined
              ? customValues[field.fieldKey]
              : userData[field.fieldKey];
          if (field.fieldType === "date" && raw) {
            const dateValue = new Date(raw);
            const formattedDate = dateValue.toISOString().split("T")[0];
            initialDynamicFieldValues[field.fieldKey] = formattedDate;
          } else if (field.fieldType === "checkbox") {
            initialDynamicFieldValues[field.fieldKey] =
              raw === true || raw === 1 || raw === "1" || raw === "true";
          } else {
            initialDynamicFieldValues[field.fieldKey] = raw ?? "";
          }
          initialDynamicFieldErrors[field.fieldKey] = "";
        });
        setDynamicFieldValues(initialDynamicFieldValues);
        setDynamicFieldErrors(initialDynamicFieldErrors);
        // Update oldValues to include dynamic field values for change detection
        setOldValues((prev) => ({
          ...prev,
          ...initialDynamicFieldValues,
        }));
      }
      // Reset Dynamic Field Values and Errors if no dynamic fields are returned
      if (!dynamicFields || dynamicFields.length === 0) {
        setDynamicFieldValues({});
        setDynamicFieldErrors({});
      }
    } catch (error) {
      console.error("Error fetching dynamic fields:", error);
      setDynamicFields([]);
      // Base rules are per country too, so a failed fetch must not leave the
      // previously loaded user's country deciding what this form shows.
      setBaseRules({});
    }
  };

  const handleSubmit = async () => {
    // e.preventDefault()
    const token = await getToken();

    try {
      // Get the token from your custom hook
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: token, // Include the token in the header if required
        },
      };

      const response = await axios.get(
        `${
          process.env.REACT_APP_API_ENDPOINT
        }/v1/installers/view?userId=${encodeURIComponent(userId)}${
          supplierType === "vendor" ? "&sub=true" : ""
        }`,
        config,
      );

      const userData = response.data.installer[0];
      setOldValues(userData);

      setResponseData(userData);
      setProfileFormData(userData);
      // Preselect Business Type field from the user's assigned business types
      const businessTypeIds = (userData.businessTypes || []).map(
        (businessType: { id: number }) => businessType.id,
      );
      setProfileFormData((prev) => ({
        ...prev,
        businessTypeId: businessTypeIds,
      }));
      setValues((prev) => ({ ...prev, businessTypeId: businessTypeIds }));
      setOldValues((prev) => ({ ...prev, businessTypeId: businessTypeIds }));
      if (supplierType === "vendor" && userData.vendorId) {
        fetchManagersData(String(userData.vendorId));
      }
      fetchFrontlineData(userData.regionId);
      const primaryBusinessTypeId = userData.businessTypes?.[0]?.id;
      fetchRolesData(primaryBusinessTypeId);
      fetchUserQualifications(userData.userId);
      setPassportTypeId(userData.passportTypeId || "");
      await fetchCountryData(userData.frontlineId);
      setSelectedCountry(userData.countryId);
      setBlockReason(userData.statusReason || "");
      setStatusEndDate(userData.statusEndDate || "");
      // Fetch custom fields for the user's country
      if (userData.countryId) {
        await getDynamicFieldsForUserCountry(userData);
      }
      // Optionally reset form after successful submission
      setValues({});
    } catch (error) {
      // Handle error if the request fails
      setError(
        `Error fetching user: ${
          error?.response?.data?.message ?? error?.message ?? String(error)
        }`,
      );
    }
  };

  const fetchUserQualifications = async (userId: string) => {
    const token = await getToken();
    const loadingToken = beginLoading("profile-qual-user-qualifications");
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT}/v1/trainings/userQualifications?userId=${userId}`,
        config,
      );
      const userQualificationsResponse =
        response?.data as UserQualificationResponseType[];
      const userQualificationsList =
        userQualificationsResponse &&
        userQualificationsResponse[0] &&
        userQualificationsResponse[0].qualifications
          ? userQualificationsResponse[0].qualifications
          : [];
      const formattedQualifications = formatUserQualificationResponse(
        userQualificationsList,
      );
      setQualificationsList(formattedQualifications);
      setOldValues((prevValues) => ({
        ...prevValues,
        trainingData: formattedQualifications,
      }));
    } catch (error) {
      console.error("Error fetching qualifications:", error);
      if (error?.response?.data?.message === "No records found") {
        setOldValues((prevValues) => ({
          ...prevValues,
          trainingData: [],
        }));
      } else {
        setAlertState({
          message: t("error_messages.fetchQualificationsShortError"),
          type: "error",
        });
      }
    } finally {
      endLoading(loadingToken); // Set loading to false after data is fetched
    }
  };

  const fieldLabelMapping: { [key: string]: keyof InstallerFormValues } = {
    "First Name": "firstName",
    "Last Name": "lastName",
    ID: "userId",
    Email: "emailId",
    "Phone Number": "contactNumber",
    Manager: "assessorName",
  };
  // BASE fields only. A country's own fields are rendered from the field schema
  // further down, so configuring one in Country Onboarding needs no change here.
  const textFieldLabels = [
    "First Name",
    "Last Name",
    "Email",
    "Phone Number",
    "Manager",
  ];

  const handleFormChange = (
    e: React.ChangeEvent<{ value: unknown; name?: string }>,
  ) => {
    const { name, value } = e.target;
    if (!name) return;
    // 🔹 If frontline changes — reset dependent fields
    if (name === "frontlineId") {
      const updatedData = {
        ...profileFormData,
        [name]: value,
        countryId: "", // reset country
        qualified: "", // reset qualified
        companyCode: "", // reset company
        companyFirstName: "", // reset first name
        companyLastName: "", // reset last name
        // status: initialData.status || "active", // Reset to initial
        blockReason: "", // Reset block reason
      };
      setProfileFormData(updatedData);
      setValues((prev) => ({
        ...prev,
        frontlineId: value as string,
        country: "", // reset country
        qualified: [], // reset qualified
        company: "", // reset company
      }));

      // Clear selected country & fetch new data
      setSelectedCountry("");
      fetchCountryData(value as string);
      return;
    }
    // 🔹 Normal updates for other fields
    setProfileFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setValues((prev) => ({
      ...prev,
      [name]: value,
    }));

    // 🔹 Country-specific logic
    if (name === "countryId") {
      const selectedCountryId = value as string;
      setSelectedCountry(selectedCountryId);
      setValues((prev) => ({
        ...prev,
        country: selectedCountryId,
      }));
      const countryCode = getCountryCodeById(selectedCountryId);
      if (countryCode) {
        fetchVendorsData(countryCode);
      }
      // Fetch custom fields when the country changes
      if (selectedCountryId) {
        getDynamicFieldsForUserCountry({
          ...profileFormData,
          countryId: selectedCountryId,
        });
      }
      const validationError = validateField("country", value as string);
      setErrors((prevErrors) => ({
        ...prevErrors,
        country: validationError,
      }));
      return;
    }

    // 🔹 Validate the field dynamically
    const fieldError = validateField(
      name,
      value as string,
      supplierType === "vendor",
    );
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: fieldError, // ✅ Clears error automatically when valid
    }));
  };

  const handleImageChange = (base64Image: string, fileType: string) => {
    setValues({
      ...values,
      photo: base64Image, // Set the Base64 image string to the form state
      fileType: fileType,
    });
  };

  const handleFieldChange =
    (field: keyof InstallerFormValues, value) =>
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setValues({
        ...values,
        [field]: e.target.value,
      });
    };
  const handleTrainingData = (
    trainings: any[],
    passportLevel: string,
    qualificationType: string,
  ) => {
    setTrainingData(trainings); // Update state with the new training data
    setValues({
      ...values,
      trainingData: trainings,
      passportLevel: passportLevel,
      qualificationType: qualificationType,
    });
  };

  const handleStatusChange = (status: string) => {
    handleFormChange({
      target: { name: "status", value: status },
    });

    // If status is active then set the statusStartDate to null, else set it to current date.
    // This is to handle the case when status is changed from active to inactive or blocked.
    if (status === "active") {
      setValues((prev) => ({
        ...prev,
        statusStartDate: null,
      }));
    } else {
      setValues((prev) => ({
        ...prev,
        statusStartDate: new Date().toISOString(),
      }));
    }
  };

  // Handle dynamic field change with validation
  const handleDynamicFieldChange = (
    fieldKey: string,
    value: string,
    field: any,
  ) => {
    // For text fields, validate character limit
    if (field.fieldType === "text" && field.charLimit) {
      if (value.length > field.charLimit) {
        setDynamicFieldErrors((prev) => ({
          ...prev,
          [fieldKey]: t("validation.maxCharactersAllowed", {
            charLimit: field.charLimit,
          }),
        }));
        return; // Don't update value if it exceeds limit
      } else {
        // Clear error if within limit
        setDynamicFieldErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[fieldKey];
          return newErrors;
        });
      }
    }

    // Update the dynamic field value
    setDynamicFieldValues((prev) => ({
      ...prev,
      [fieldKey]: value,
    }));
  };

  // Validate dynamic fields
  const validateDynamicFields = () => {
    const errors: { [key: string]: string } = {};

    dynamicFields.forEach((field: any) => {
      const value = dynamicFieldValues[field.fieldKey];

      // Check if mandatory field is empty
      const isEmpty =
        value === undefined ||
        value === null ||
        value === "" ||
        value === false ||
        (typeof value === "string" && value.trim() === "");
      if (field.isMandatory === 1 && isEmpty) {
        errors[field.fieldKey] = t("validation.displayNameRequired", {
          displayName: field.displayName,
        });
      }

      // Check character limit for text fields
      if (
        field.fieldType === "text" &&
        field.charLimit &&
        typeof value === "string" &&
        value.length > field.charLimit
      ) {
        errors[field.fieldKey] = t("validation.maxCharactersAllowed", {
          charLimit: field.charLimit,
        });
      }
    });

    return errors;
  };

  const renderDynamicFields = () => {
    if (!dynamicFields || dynamicFields.length === 0) return null;
    return dynamicFields.map((field) => (
      <Grid item xs={12} key={field.fieldKey}>
        {field.fieldType === "text" && (
          <TextField
            label={field.displayName}
            fullWidth
            value={dynamicFieldValues[field.fieldKey] || ""}
            onChange={(e) =>
              handleDynamicFieldChange(field.fieldKey, e.target.value, field)
            }
            sx={{
              backgroundColor: "#e7eaf6",
              borderRadius: 2,
            }}
            required={field.isMandatory === 1}
            error={!!dynamicFieldErrors[field.fieldKey]}
            helperText={dynamicFieldErrors[field.fieldKey] || ""}
            inputProps={{
              maxLength: field.charLimit || undefined,
            }}
          />
        )}
        {field.fieldType === "date" && (
          <TextField
            label={field.displayName}
            type="date"
            fullWidth
            value={dynamicFieldValues[field.fieldKey] || ""}
            onChange={(e) =>
              handleDynamicFieldChange(field.fieldKey, e.target.value, field)
            }
            sx={{
              backgroundColor: "#e7eaf6",
              borderRadius: 2,
            }}
            InputLabelProps={{
              shrink: true,
            }}
            required={field.isMandatory === 1}
            error={!!dynamicFieldErrors[field.fieldKey]}
            helperText={dynamicFieldErrors[field.fieldKey]}
          />
        )}
        {field.fieldType === "number" && (
          <TextField
            label={field.displayName}
            type="number"
            fullWidth
            value={dynamicFieldValues[field.fieldKey] || ""}
            onChange={(e) =>
              handleDynamicFieldChange(field.fieldKey, e.target.value, field)
            }
            sx={{
              backgroundColor: "#e7eaf6",
              borderRadius: 2,
            }}
            required={field.isMandatory === 1}
            error={!!dynamicFieldErrors[field.fieldKey]}
            helperText={dynamicFieldErrors[field.fieldKey] || ""}
          />
        )}
        {field.fieldType === "dropdown" && (
          <FormControl
            fullWidth
            required={field.isMandatory === 1}
            error={!!dynamicFieldErrors[field.fieldKey]}
          >
            <InputLabel shrink>{field.displayName}</InputLabel>
            <Select
              value={dynamicFieldValues[field.fieldKey] || ""}
              displayEmpty
              label={field.displayName}
              onChange={(e) =>
                handleDynamicFieldChange(field.fieldKey, e.target.value, field)
              }
              sx={{
                backgroundColor: "#e7eaf6",
                borderRadius: 2,
              }}
            >
              {(field.fieldOptions || []).map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        {field.fieldType === "checkbox" && (
          <FormControlLabel
            control={
              <Checkbox
                checked={
                  dynamicFieldValues[field.fieldKey] === true ||
                  dynamicFieldValues[field.fieldKey] === "true"
                }
                onChange={(e) =>
                  handleDynamicFieldChange(
                    field.fieldKey,
                    e.target.checked,
                    field,
                  )
                }
              />
            }
            label={`${field.displayName}${field.isMandatory === 1 ? " *" : ""}`}
          />
        )}
      </Grid>
    ));
  };

  const handleQualificationEditClick = () => {
    if (adminRole === CONSTANTS.ADMIN_ROLES.SUBCON_ADMIN) {
      setAlertState({
        type: "error",
        message: t(
          "adminDashboard.form.addInstaller.errorMessage.subconAdminQualificationRestriction",
        ),
      });
      return false;
    }
    return true;
  };

  return (
    <Dialog
      open={openDialog}
      onClose={(event, reason) => handleCancel(event, reason)}
      fullWidth // Make the dialog occupy full width of its container
      maxWidth="md" // Set max width to 'md' or any other desired breakpoint (sm, md, lg, xl)
      sx={{ minWidth: 600, backgroundColor: "rgba(255, 255, 255, 0.8)" }} // Optional: Set a minimum width if needed
    >
      <>
        {loading && <Loading />}
        <DialogTitle>
          {data.firstName} {data.lastName}
        </DialogTitle>
        <DialogContent>
          {alertState.type && (
            <div className="alert-box">
              <AlertBox
                type={alertState.type}
                message={alertState.message}
                onCloseCb={handleCloseAlert}
              />
            </div>
          )}
          {showAlert && (
            <Alert severity="success" style={{ marginBottom: "16px" }}>
              {successMessage}
            </Alert>
          )}
          <Grid container spacing={2} minWidth={"md"}>
            {/* Left Section: Photo & Dropdown Fields */}
            <Grid item xs={4} md={5}>
              <Grid container direction="column" spacing={1}>
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid
                      item
                      xs={8}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        // alignItems: "center",
                      }}
                    >
                      <ImageUpload
                        photo={values.photo || photo} // A newly picked image, else the stored one
                        onImageChange={handleImageChange} // Pass handler to update form state
                        setAlertBoxState={setAlertState}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={4}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        padding: "none",
                      }}
                    >
                      <StatusCardProps
                        initialStatus={values.status || profileFormData.status}
                        onStatusChange={(status) => handleStatusChange(status)}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* Business Type Dropdown */}
                <Grid item xs={12}>
                  <Typography variant="body1">
                    {t(
                      "adminDashboard.dropdownSelection.businessType",
                      "Business Type",
                    )}
                  </Typography>
                  <FormControl
                    fullWidth
                    sx={{ backgroundColor: "#e7eaf6", borderRadius: 2 }}
                  >
                    <Select
                      multiple
                      value={profileFormData.businessTypeId || []}
                      onChange={(e) => {
const selectedValues = Array.isArray(e.target.value)
  ? e.target.value.map((v) => Number(v))
  : [];
                        setProfileFormData((prev) => ({
                          ...prev,
                          businessTypeId: selectedValues,
                        }));
                        setValues((prev) => ({
                          ...prev,
                          businessTypeId: selectedValues,
                        }));
                        const validationError = validateField(
                          "businessTypeId",
                          selectedValues,
                        );
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          businessTypeId: validationError,
                        }));
                      }}
                      renderValue={(selected) =>
                        selected
                          .map(
                            (id) =>
                              businessTypesList?.find(
                                (bt) => bt.businessTypeId === Number(id),
                              )?.businessTypeName,
                          )
                          .filter((name) => name)
                          .map((name) => t(`businessTypes.${name}`, name))
                          .join(", ")
                      }
                      sx={{ backgroundColor: "#e7eaf6", borderRadius: 2 }}
                      fullWidth
                      required
                      id="businessTypeId"
                      name="businessTypeId"
                      error={!!errors.businessTypeId}
                    >
                      {businessTypesList?.map((bt) => (
                        <MenuItem
                          key={bt.businessTypeId}
                          value={bt.businessTypeId}
                        >
                          <Checkbox
                            checked={
                              profileFormData.businessTypeId?.includes(
                                bt.businessTypeId,
                              ) || false
                            }
                          />
                          {t(
                            `businessTypes.${bt.businessTypeName}`,
                            bt.businessTypeName,
                          )}
                        </MenuItem>
                      ))}
                    </Select>
                    <TextLabel type="errorText">
                      {errors.businessTypeId ? errors.businessTypeId : ""}
                    </TextLabel>
                  </FormControl>
                </Grid>

                {/* Frontline Dropdown */}

                <Grid item xs={12}>
                  <Typography variant="body1">
                    {t("adminDashboard.form.updateInstaller.labels.frontline")}{" "}
                    {/* This is the label for the field */}
                  </Typography>
                  <FormControl
                    fullWidth
                    sx={{ backgroundColor: "#e7eaf6", borderRadius: 2 }}
                  >
                    <Select
                      value={profileFormData.frontlineId}
                      onChange={handleFormChange}
                      sx={{ backgroundColor: "#e7eaf6", borderRadius: 2 }}
                      fullWidth
                      required
                      id="frontlineId"
                      name="frontlineId"
                      error={!!errors.frontline}
                    >
                      {frontlineList.map((frontline) => (
                        <MenuItem
                          key={frontline.frontline_id}
                          value={frontline.frontline_id}
                          disabled={
                            frontline.status === CONSTANTS.STATUS.INACTIVE
                          }
                        >
                          {frontline.frontline_code}
                        </MenuItem>
                      ))}
                    </Select>
                    <TextLabel type="errorText">
                      {errors.frontline ? errors.frontline : ""}
                    </TextLabel>
                  </FormControl>
                </Grid>

                {/* Country Dropdown */}
                <Grid item xs={12}>
                  <Typography variant="body1">
                    {t("adminDashboard.form.updateInstaller.labels.country")}{" "}
                    {/* This is the label for the field */}
                  </Typography>
                  <FormControl
                    fullWidth
                    sx={{ backgroundColor: "#e7eaf6", borderRadius: 2 }}
                  >
                    <Select
                      value={profileFormData.countryId}
                      onChange={(e) => {
                        handleFormChange(e);
                        const selectedCountryId = e.target.value as string;
                        setSelectedCountry(selectedCountryId);
                        const countryCode =
                          getCountryCodeById(selectedCountryId);
                        if (countryCode) {
                          fetchVendorsData(countryCode);
                        }
                      }}
                      sx={{ backgroundColor: "#e7eaf6", borderRadius: 2 }}
                      fullWidth
                      required
                      id="countryId"
                      name="countryId"
                      error={!!errors.country}
                    >
                      {countryList &&
                        countryList.map((country) => (
                          <MenuItem
                            key={country.country_id}
                            value={country.country_id}
                            disabled={
                              country.status === CONSTANTS.STATUS.INACTIVE
                            }
                          >
                            {country.name}
                          </MenuItem>
                        ))}
                    </Select>
                    <TextLabel type="errorText">
                      {errors.country ? errors.country : ""}
                    </TextLabel>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <FormControl
                    fullWidth
                    sx={{ backgroundColor: "#e7eaf6", borderRadius: 2 }}
                  >
                    <Autocomplete
                      options={companyList}
                      getOptionLabel={(option) => option.firstName}
                      value={
                        companyList.find(
                          (company) =>
                            company.id === profileFormData.companyCode,
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          company: undefined, // Clear error on selection
                        }));
                        // Candidate managers belong to the vendor, so moving the
                        // employee invalidates any manager already chosen.
                        setProfileFormData((prev) => ({
                          ...prev,
                          companyCode: newValue ? newValue.id : "",
                          managerId: "",
                        }));
                        setValues((prev) => ({
                          ...prev,
                          company: newValue ? newValue.id : "",
                          managerId: "",
                        }));
                        if (supplierType === "vendor") {
                          fetchManagersData(newValue ? String(newValue.id) : "");
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={t(
                            "adminDashboard.form.updateInstaller.labels.company",
                          )}
                          sx={{ backgroundColor: "#e7eaf6", borderRadius: 2 }}
                          required
                          fullWidth
                          id="companyCode"
                          name="companyCode"
                          error={!!errors.company}
                          helperText={
                            errors.company || companyList.length === 0
                              ? t(
                                  "adminDashboard.form.updateInstaller.helperText.no_company",
                                )
                              : ""
                          }
                        />
                      )}
                    />
                  </FormControl>
                </Grid>

                {/* Qualified Dropdown */}
                <Grid item xs={12}>
                  <FormControl
                    fullWidth
                    sx={{ backgroundColor: "#e3f2fd", borderRadius: 2 }}
                  >
                    <InputLabel>
                      {t(
                        "adminDashboard.form.updateInstaller.labels.qualifiedToWork",
                      )}
                    </InputLabel>
                    <Select
                      id="qualified"
                      name="qualified"
                      multiple
                      value={
                        profileFormData.qualified
                          ? profileFormData.qualified.split(",")
                          : []
                      } // Ensure this is an array
                      onChange={(e) => {
                        const value = e.target.value as string[];
                        if (value.length > 0) {
                          setProfileFormData({
                            ...profileFormData,
                            qualified: value.join(","),
                          });
                          setValues({
                            ...values,
                            qualified: value.join(","),
                          });
                        }
                      }} // Handle multiple values
                      renderValue={(selected) => {
                        // Display the names of the selected countries
                        return selected
                          .map((countryId) => {
                            const country = countryList.find(
                              (c) => c.country_id.toString() === countryId,
                            );
                            return country ? country.name : "";
                          })
                          .filter((name) => name) // Filter out empty names
                          .join(", "); // Join names with commas
                      }}
                      sx={{ backgroundColor: "#e7eaf6", borderRadius: 2 }}
                    >
                      {countryList.map((country) => (
                        <MenuItem
                          key={country.country_id}
                          value={country.country_id.toString()}
                          disabled={
                            country.status === CONSTANTS.STATUS.INACTIVE
                          }
                        >
                          <Checkbox
                            checked={
                              profileFormData.qualified
                                ? profileFormData.qualified
                                    .split(",")
                                    .includes(country.country_id.toString())
                                : false
                            }
                          />
                          {country.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              {showBaseField("koneEmployeeId") && (
                <Grid item xs={12}>
                  <TextLabel type="labelText">
                    {supplierType === "vendor"
                      ? t(
                          "adminDashboard.form.updateInstaller.labels.smpEmployeeId",
                        )
                      : t(
                          "adminDashboard.form.updateInstaller.labels.koneEmployeeId",
                        )}
                  </TextLabel>
                  <TextField
                    fullWidth
                    value={profileFormData.koneEmployeeId || ""}
                    onChange={handleFormChange}
                    sx={{ backgroundColor: "#e7eaf6", borderRadius: 2 }}
                    disabled={supplierType === "vendor"}
                    required={requireBaseField("koneEmployeeId", false)}
                    id="koneEmployeeId"
                    name="koneEmployeeId"
                  />
                </Grid>
              )}
            </Grid>

            {/* Right Section: Personal Information */}
            <Grid item xs={8} md={7}>
              <Box sx={{ padding: 2, borderRadius: 2 }}>
                <Grid container spacing={2}>
                  {/* Personal Info Fields */}
                  {textFieldLabels.map((label) => {
                    const field = fieldLabelMapping[label];
                    const errorMessage = errors[field];
                    // Should not show Manager field for vendor users
                    if (supplierType === "vendor" && field === "assessorName") {
                      return null;
                    }
                    // Hidden for this country in its field configuration.
                    if (!showBaseField(field)) {
                      return null;
                    }

                    return (
                      <Grid item xs={12} key={label}>
                        <TextLabel type="labelText">
                          {t(
                            `adminDashboard.form.updateInstaller.labels.${field}`,
                          )}
                        </TextLabel>
                        <TextField
                          fullWidth
                          value={profileFormData[field]}
                          onChange={handleFormChange}
                          sx={{ backgroundColor: "#e7eaf6", borderRadius: 2 }}
                          // Email stays optional for subcontractor employees
                          // regardless of country; otherwise follow the
                          // country's rule, defaulting to the form's own.
                          required={
                            field === "emailId" && supplierType === "vendor"
                              ? false
                              : requireBaseField(field, false)
                          }
                          error={!!errorMessage}
                          helperText={errorMessage}
                          id={field}
                          name={field}
                          InputProps={
                            field === "contactNumber" && {
                              startAdornment: (
                                <InputAdornment position="start">
                                  {profileFormData.countryId &&
                                    countryList.find(
                                      (country) =>
                                        country.country_id ===
                                        profileFormData.countryId,
                                    )?.phone_code}
                                </InputAdornment>
                              ),
                            }
                          }
                        />
                      </Grid>
                    );
                  })}
                  {/* Manager (foreman). Subcontractor employees only - a KONE
                      employee's manager comes from Workday and is shown as the
                      read-only assessorName field above. */}
                  {supplierType === "vendor" && (
                    <Grid item xs={12}>
                      <TextLabel type="labelText">
                        {t("adminDashboard.form.updateInstaller.labels.manager")}
                      </TextLabel>
                      <FormControl
                        fullWidth
                        sx={{ backgroundColor: "#e7eaf6", borderRadius: 2 }}
                      >
                        <Autocomplete
                          options={managerList}
                          getOptionLabel={(option) => option.name}
                          renderOption={(props, option) => (
                            <li
                              {...props}
                              key={option.id}
                              title={
                                option.smpEmployeeId
                                  ? `${option.name} (${option.smpEmployeeId})`
                                  : option.name
                              }
                            >
                              {option.name}
                            </li>
                          )}
                          filterOptions={(options, { inputValue }) => {
                            // The SMP id used to be part of the label, which made
                            // it searchable. It only shows on hover now, so match
                            // on it explicitly rather than quietly losing that.
                            const query = inputValue.trim().toLowerCase();
                            if (!query) return options;
                            return options.filter((option) =>
                              `${option.name} ${option.smpEmployeeId || ""}`
                                .toLowerCase()
                                .includes(query),
                            );
                          }}
                          disabled={!profileFormData.companyCode}
                          noOptionsText={t(
                            "adminDashboard.form.updateInstaller.labels.noManagersFound",
                          )}
                          value={
                            managerList.find(
                              (manager) =>
                                String(manager.id) ===
                                String(profileFormData.managerId),
                            ) || null
                          }
                          onChange={(event, newValue) => {
                            // An empty string clears the manager; the update
                            // endpoint treats that as "remove", not "unchanged".
                            setProfileFormData((prev) => ({
                              ...prev,
                              managerId: newValue ? newValue.id : "",
                            }));
                            setValues((prev) => ({
                              ...prev,
                              managerId: newValue ? newValue.id : "",
                            }));
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              sx={{
                                backgroundColor: "#e7eaf6",
                                borderRadius: 2,
                              }}
                              fullWidth
                              id="managerId"
                              name="managerId"
                            />
                          )}
                        />
                      </FormControl>
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    {/* <Typography variant="body1">
                      {t("adminDashboard.form.updateInstaller.labels.jobTitle")}
                    </Typography> */}
                    <FormControl
                      fullWidth
                      sx={{ backgroundColor: "#e7eaf6", borderRadius: 2 }}
                    >
                      <Autocomplete
                        options={installerRoleList}
                        getOptionLabel={(option) => option.role_name}
                        value={
                          installerRoleList.find(
                            (role) => role.role_id === profileFormData.roleId,
                          ) || null
                        }
                        onChange={(event, newValue) => {
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            role: undefined, // Clear error on selection
                          }));
                          const selectedRoleId = newValue
                            ? newValue.role_id
                            : "";
                          if (newValue?.role_name === "Others") {
                            setProfileFormData((prev) => ({
                              ...prev,
                              customRoleName: prev.customRoleName || "", // Retain existing value if available
                              roleId: selectedRoleId,
                            }));
                            setValues((prev) => ({
                              ...prev,
                              roleId: selectedRoleId,
                            }));
                          } else {
                            setProfileFormData((prev) => ({
                              ...prev,
                              customRoleName: "", // Clear role description if not "Others"
                              roleId: selectedRoleId,
                            }));
                            setValues((prev) => ({
                              ...prev,
                              roleId: selectedRoleId,
                              customRoleName: "",
                            }));
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={t(
                              "adminDashboard.form.updateInstaller.labels.jobTitle",
                            )}
                            sx={{ backgroundColor: "#e7eaf6", borderRadius: 2 }}
                            required
                            fullWidth
                            id="roleId"
                            name="roleId"
                            error={!!errors.role}
                            helperText={
                              errors.role || installerRoleList.length === 0
                                ? t(
                                    "adminDashboard.form.updateInstaller.helperText.no_role",
                                  )
                                : ""
                            }
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>
                  {installerRoleList.some(
                    (role) =>
                      role.role_id === profileFormData?.roleId &&
                      role.role_name === "Others",
                  ) && (
                    <Grid item xs={12}>
                      <Typography variant="body1">
                        {t(
                          "adminDashboard.form.updateInstaller.labels.customRoleName",
                        )}
                      </Typography>
                      <TextField
                        fullWidth
                        value={profileFormData.customRoleName || ""}
                        onChange={(e) => {
                          handleFormChange(e);
                          setProfileFormData((prev) => ({
                            ...prev,
                            customRoleName: e.target.value,
                          }));
                        }}
                        sx={{ backgroundColor: "#e7eaf6", borderRadius: 2 }}
                        id="customRoleName"
                        name="customRoleName"
                      />
                    </Grid>
                  )}

                  {/* Dynamic Fields */}
                  {renderDynamicFields()}

                  {/* Comments Field */}
                  {showBaseField("comments") && (
                    <Grid item xs={12}>
                      <Typography variant="body1">
                        {t(
                          "adminDashboard.form.updateInstaller.labels.comments",
                        )}
                      </Typography>
                      <TextField
                        value={profileFormData.comments}
                        variant="outlined"
                        fullWidth
                        onChange={handleFormChange}
                        id="comments"
                        name="comments"
                        sx={{ backgroundColor: "#e7eaf6", borderRadius: 2 }}
                      />
                    </Grid>
                  )}
                </Grid>
              </Box>
            </Grid>

            {/* Training List */}
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                padding: 0,
                margin: 0,
              }}
            ></Grid>
            {/* Action Buttons */}

            {
              <TrainingList
                handleTrainingData={handleTrainingData}
                profileFormData={profileFormData}
                countryList={countryList}
                onEditClick={handleQualificationEditClick}
              />
            }
            {/* </Box> */}

            <Grid container spacing={3} justifyContent="center" sx={{ mt: 2 }}>
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    mt: 2,
                    px: 2,
                  }}
                >
                  <StyledButtons.DeleteButton
                    startIcon={<DeleteIcon />}
                    onClick={handleDeleteClick}
                    disabled={showAlert}
                  >
                    {t("adminDashboard.form.button.deleteProfile")}
                  </StyledButtons.DeleteButton>

                  <Box sx={{ display: "flex", gap: 2 }}>
                    <StyledButtons.SecondaryButton onClick={handleCancel}>
                      {t("adminDashboard.form.button.cancel")}
                    </StyledButtons.SecondaryButton>
                    <StyledButtons.PrimaryButton
                      type="submit"
                      onClick={handleUpdate}
                      disabled={showAlert}
                    >
                      {t("adminDashboard.form.button.update")}
                    </StyledButtons.PrimaryButton>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={showDeleteDialog}
        onClose={handleDeleteCancel}
        maxWidth="sm"
        fullWidth
      >
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              py: 3,
            }}
          >
            <Typography
              variant="body1"
              sx={{
                textAlign: "center",
                mb: 1,
              }}
            >
              {t("adminDashboard.form.deleteConfirmation.message")}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                textAlign: "center",
                fontWeight: "bold",
                mb: 3,
              }}
            >
              {profileFormData.firstName} {profileFormData.lastName}
            </Typography>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                justifyContent: "center",
              }}
            >
              <StyledButtons.SecondaryButton onClick={handleDeleteCancel}>
                {t("adminDashboard.form.button.cancel")}
              </StyledButtons.SecondaryButton>
              <StyledButtons.PrimaryButton onClick={handleDeleteConfirm}>
                {t("adminDashboard.form.button.delete")}
              </StyledButtons.PrimaryButton>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </Dialog>
  );
};

export default ProfileWithQual;
